// extracted by mini-css-extract-plugin
module.exports = {"recruit":"LandingRecruit_recruit__zlOxA","logos":"LandingRecruit_logos__VD6k_","sub_text":"LandingRecruit_sub_text__C4hVH","recruit_button":"LandingRecruit_recruit_button__tvN1e"};